import { Injectable } from '@angular/core';
import { PasFeature } from '@ddt-web/data-service';
import { AssetResolveResponse, PasPortfolioPosition } from '@ddt-web/pas';
import { Store } from '@ngrx/store';

import { triggeredPositionPerHolding, triggeredPositionPerHoldingCompare, triggeredTaxPerHolding } from '../../../store/data-loading.actions';
import { PasPostProcessingService } from './pas-post-processing.service';

/**
 * Service that processes the WWE store dispatch with triggeredPositionPerHolding action for security-details per holding API response for IQ.
 */
@Injectable()
export class PasPositionDetailsPerHoldingProcessingService extends PasPostProcessingService {

	constructor(private store: Store) {
		super();
	}

	public process(portfoliosToLoad: PasPortfolioPosition[], ids?: string[], positionDataFromApiCall?: AssetResolveResponse, feature?: PasFeature): void {
		if (feature === PasFeature.COMPARE) {
			this.store.dispatch(triggeredPositionPerHoldingCompare({ payload: portfoliosToLoad }));
		} else if (feature === PasFeature.WORST_TAX_OFFENDERS) {
			this.store.dispatch(triggeredTaxPerHolding({ payload: portfoliosToLoad }));
		} else {
			this.store.dispatch(triggeredPositionPerHolding({ payload: portfoliosToLoad }));
		}
	}
}
